import { isPast } from 'date-fns';
import { TimelineNode } from '../types';

export const getExtraDropzoneStatus = (previousNode?: TimelineNode) => {
  if (previousNode) {
    return isPast(previousNode.startDate) && isPast(previousNode.endDate);
  }
  return false;
};
